"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    allowHideAfter: {
        type: Number,
        default: undefined
    },
    animation: {
        type: [Object, Boolean],
        default: undefined
    },
    appendTo: {
        type: [String, Object],
        default: undefined
    },
    autoHideAfter: {
        type: Number,
        default: undefined
    },
    button: {
        type: Boolean,
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    hideOnClick: {
        type: Boolean,
        default: undefined
    },
    position: {
        type: Object,
        default: undefined
    },
    stacking: {
        type: String,
        default: undefined
    },
    templates: {
        type: Array,
        default: undefined
    },
    width: {
        type: [Number, String],
        default: undefined
    },

    // Events
    hide: Function,
    show: Function
};